module.exports = __webpack_public_path__ + "static/media/icon-winner.89a3a6a4.webp";